import { render, staticRenderFns } from "./PasswordSetup.vue?vue&type=template&id=b00e0cd0"
import script from "./PasswordSetup.vue?vue&type=script&lang=js"
export * from "./PasswordSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports